import React from "react"
import { useSelector } from "react-redux"
import ImageGalleryUI from "@/components/MultiFinshProductBundle/ui/ImageGalleryUI"
import ProductOptionSelector from "@/components/MultiFinshProductBundle/ProductOptionSelector"
import BundleDetailsAccordian from "@/components/MultiFinshProductBundle/BundleDetailsAccordian"
import ProductActions from "@/components/MultiFinshProductBundle/ProductActions"
import BundleInfo from "@/components/MultiFinshProductBundle/BundleInfo"
import BundleSelectedProductList from "@/components/MultiFinshProductBundle/BundleSelectedProductList"
import BundleProductBreadcrumb from "@/components/MultiFinshProductBundle/BundleProductBreadcrumb"

import usePdpi18n from "@/i18n/usePdpi18n"
import { getShortenedUrlwithGeneral } from "@/utils/helper"
import { isObjectEmpty } from "@/utils/index"
import useWindowResize from "@/hooks/useWindowResize"
import { selectGenericState } from "@/store/features/genericSlice"

import Styles from "@/components/MultiFinshProductBundle/styles/MultiFinshProductBundleUI.module.scss"

const MultiFinshProductBundleUI = props => {
  const {
    bundlePdpData = {},
    isPriceLoading = true,
    finalProductPrice = 0,
    skusPrice = [],
    selectedProducts = [],
    quickViewAuthData = {},
    authoredData = {},
    config = {},
    productInfoBundle = [],
    avaiableColors = [],
    swatchName = "",
    handleClickSwatch = () => {},
    addCartRef = null,
    allImages = [],
    layeredIMageURL = "",
    setTriggerAnalyticsOnProductClick = () => {},
  } = props || {}

  const { globalConfig } = useSelector(selectGenericState)

  const configData = !isObjectEmpty(config) ? config : globalConfig

  const {
    pdpDetails: { name = "", productLocalCategory = "" },
    bundleItems = [],
  } = bundlePdpData

  const { presetConfigs = "{}" } = authoredData
  const { general = {} } = configData

  const {
    homepageUrl = "",
    newBadgeName = "",
    saleBadgeName = "",
    exclusiveBadgeName = "",
    discontinuedBadgeName = "",
    swatchUrl = "",
  } = general

  const badgeText = {
    new: newBadgeName,
    onSale: saleBadgeName,
    exclusive: exclusiveBadgeName,
    discontinued: discontinuedBadgeName,
  }
  const staticTexts = usePdpi18n(authoredData, badgeText, name)

  const homePagePath = getShortenedUrlwithGeneral(homepageUrl, general)
  const [width] = useWindowResize()

  const presetConfigObject = JSON.parse(presetConfigs)

  return (
    <div className={Styles.MultiFinshProductBundleUI}>
      <BundleProductBreadcrumb
        staticTexts={staticTexts}
        productCategory={productLocalCategory}
        name={name}
        homePagePath={homePagePath}
        swatchUrl={swatchUrl}
        width={width}
        presetConfigObject={presetConfigObject}
        isBundleProduct={true}
        productInfoBundle={productInfoBundle}
      />
      <section className="product-details">
        <div className="left-side-container">
          <div className="sticky-container">
            <ImageGalleryUI
              config={configData}
              data={allImages}
              layerImageData={{ layerUrl: layeredIMageURL }}
              productInfoBundle={productInfoBundle}
            />
          </div>
        </div>

        <div className="right-side-container">
          <BundleInfo
            isPriceLoading={isPriceLoading}
            bundlePdpData={bundlePdpData}
            finalProductPrice={finalProductPrice}
            config={configData}
            avaiableColors={avaiableColors}
            swatchName={swatchName}
            handleClickSwatch={handleClickSwatch}
          />
          {bundleItems.map((item, index) => {
            return (
              <React.Fragment key={item.name}>
                <ProductOptionSelector
                  data={item}
                  index={index}
                  quickViewAuthData={quickViewAuthData}
                  authoredData={authoredData}
                  config={configData}
                  swatchName={swatchName}
                  productInfoBundle={productInfoBundle}
                  skusPrice={skusPrice}
                  finalProductPrice={finalProductPrice}
                  selectedProducts={selectedProducts}
                  setTriggerAnalyticsOnProductClick={
                    setTriggerAnalyticsOnProductClick
                  }
                />
              </React.Fragment>
            )
          })}

          <BundleSelectedProductList
            bundleItems={bundleItems}
            skusPrice={skusPrice}
            selectedProducts={selectedProducts}
            presetConfigObject={presetConfigObject}
            config={configData}
            isPriceLoading={isPriceLoading}
            finalProductPrice={finalProductPrice}
            productInfoBundle={productInfoBundle}
          />
          <ProductActions
            productInfoBundle={productInfoBundle}
            ref={addCartRef}
          />
          <BundleDetailsAccordian
            config={configData}
            productInfoBundle={productInfoBundle}
          />
        </div>
      </section>
    </div>
  )
}

export default MultiFinshProductBundleUI
